import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Grid,
    Card,
    CardContent,
    Divider,
    IconButton
} from '@mui/material';
import { CheckCircle, Phone, Person, DateRange, VerifiedUser, Close } from '@mui/icons-material';

const SearchQRModal = ({ open, onClose, data }) => {

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#C11D6C', color: 'white' }}>
                <span>eSIM Details</span>
                <IconButton edge="end" color="inherit" onClick={onClose}>
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card variant="outlined">
                            <CardContent>
                                <Grid item xs={12} style={{ textAlign: 'center' }}>

                                    <img src={data?.qr_code} alt="Esim" style={{
                                        width: '200px',
                                        height: '200px',
                                        border: '2px solid #C11D6C',
                                        borderRadius: '10px',
                                        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                                    }} />

                                </Grid>
                                <Grid item xs={12} style={{ textAlign: 'center', marginTop: '16px' }}>
                                    <Typography variant="body2" style={{ color: 'red' }}>
                                        Alert! Scan the QR Code to device only when the Telstra Activation Status is Active
                                    </Typography>
                                </Grid>
                                <Divider style={{ margin: '16px 0' }} />
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" style={{color:"#344767",fontSize:"16px"}}>
                                            <CheckCircle color="primary" /> <strong>eSIM Voucher Number:</strong>
                                        </Typography>
                                        <Typography variant="body2" >{data.search_result?.sim_number}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" style={{color:"#344767",fontSize:"16px"}}>
                                            <Phone color="primary" /> <strong>Mobile Number:</strong>
                                        </Typography>
                                        <Typography variant="body2">{data.search_result?.mobile_number}</Typography>
                                    </Grid>
                                </Grid>
                                <Divider style={{ margin: '16px 0' }} />
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" style={{color:"#344767",fontSize:"16px"}}>
                                            <Person color="primary" /> <strong>Customer Name:</strong>
                                        </Typography>
                                        <Typography variant="body2" >{data.search_result?.firstName}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" style={{color:"#344767",fontSize:"16px"}}>
                                            <DateRange color="primary" /> <strong>DOB:</strong>
                                        </Typography>
                                        <Typography variant="body2" >{data.search_result?.dob}</Typography>
                                    </Grid>
                                </Grid>
                                <Divider style={{ margin: '16px 0' }} />
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" style={{color:"#344767",fontSize:"16px"}}>
                                            <VerifiedUser color="primary"  /> <strong>Telstra Activation Status:</strong>
                                        </Typography>
                                        <Typography variant="body2" >{data.search_result?.telstra_activation_status}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" style={{color:"#344767",fontSize:"16px"}}>
                                            <VerifiedUser color="primary" /> <strong>eSIM Profile State:</strong>
                                        </Typography>
                                        <Typography variant="body2">{data.profileState}</Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </DialogContent>

        </Dialog>
        
    );
};

export default SearchQRModal;
